<template>
    <div class="my-mmrs">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <div style="margin-top: -8px">
            <van-tabs v-model="active" @click="onClick">
                <van-tab title="请客卡">
                    <div class="mmr-items" v-for="item in mmrs">
                        <img :src="item.imgUrl" style="width: 80px;height: 80px;">
                        <div class="mmr-item">
                            <span style="font-size: 14px;height: 23px;">{{item.icName}}</span>
                            <span style="font-size: 12px;color: #ff4d51;height: 23px;">¥ {{item.price}}</span>
                            <span style="font-size: 10px;height: 15px;line-height: 18px">限领取: {{item.skuTotal}}份</span>
                            <span style="font-size: 10px;height: 15px;line-height: 18px">已领取: {{item.quantity}}份</span>
                        </div>
                        <span class="mmr-btn" @click="toPoster(item)">请客码</span>
                    </div>
                </van-tab>
                <van-tab title="TA领取记录">
                    <div class="mrr-items" v-for="item in mrrs">
                        <div class="mrr-qkk">
                            <img :src="item.imgUrl" style="width: 60px;height: 60px;">
                            <div class="mmr-item" style="width: 70%;margin-left: 12px;">
                                <span style="font-size: 14px;height: 28px;">{{item.icName}}</span>
                                <span style="font-size: 11px;height: 15px;line-height: 18px;color: #ff4d51">¥ {{item.price}}</span>
                            </div>
                            <span style="font-size: 12px">x1</span>
                        </div>
                        <span class="mrr-sp">领取人: {{item.lqName}}</span>
                        <span class="mrr-sp">手机号码: {{item.lqPhone}}</span>
                        <span class="mrr-sp">领取时间: {{item.createTime}}</span>
                        <span class="mrr-sp">配送方式: {{item.psWay==0?'到店':'快递'}}</span>
                    </div>
                </van-tab>
                <van-tab title="我领取记录">
                    <div class="mrr-items" v-for="item in mrrs">
                        <div class="mrr-qkk">
                            <img :src="item.imgUrl" style="width: 60px;height: 60px;">
                            <div class="mmr-item" style="width: 70%;margin-left: 12px;">
                                <span style="font-size: 14px;height: 28px;">{{item.icName}}</span>
                                <span style="font-size: 11px;height: 15px;line-height: 18px;color: #ff4d51">¥ {{item.price}}</span>
                            </div>
                            <span style="font-size: 12px">x1</span>
                        </div>
                        <span class="mrr-sp">分享人: {{item.fxName}}</span>
                        <span class="mrr-sp">领取人: {{item.lqName}}</span>
                        <span class="mrr-sp">手机号码: {{item.lqPhone}}</span>
                        <span class="mrr-sp">领取时间: {{item.createTime}}</span>
                        <span class="mrr-sp">配送方式: {{item.psWay==0?'到店':'快递'}}</span>
                    </div>
                </van-tab>
                <van-tab title="配送卡">
                    <div class="mmr-items" v-for="item in mdis">
                        <img :src="item.imgUrl" style="width: 80px;height: 80px;">
                        <div class="mmr-item">
                            <span style="font-size: 14px;height: 23px;">{{item.goodsName}}</span>
                            <span style="font-size: 12px;color: #ff4d51;height: 23px;">¥ {{item.goodsPrice}}</span>
                            <span style="font-size: 10px;height: 15px;line-height: 18px">限领取: {{item.quantity}}份</span>
                            <span style="font-size: 10px;height: 15px;line-height: 18px">已领取: {{item.useNum}}份</span>
                        </div>
                        <span class="mmr-btn">推广分享码</span>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
        <van-popup v-model="showPoster">
            <div id="imageWrapper1">
                <div class="content_container">
                    <vue-canvas-poster v-if="!posterImg" :widthPixels="900" :heightPixels="1600"
                                       :painting="painting"
                                       @success="success" @fail="fail">
                    </vue-canvas-poster>
                    <van-image :src="posterImg" id="mypic" class="hb-img" crossOrigin="anonymous"/>
                </div>
            </div>
            <!--      <div style="background-color:#484848;opacity:1;display: block;">-->
            <!--        <van-button type="danger" style="width: 100%;height: 38px;line-height: 38px" @click="toSaveImage(posterImg)">保存图片</van-button>-->
            <!--      </div>-->
        </van-popup>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '请客赠送',
                active: 0,
                deptId: '',
                token: '',

                mmrs: [],
                mdis: [],

                show: false,
                lqShow: false,
                icName: '',

                showPoster: false,
                posterImg: '',//生成的海报
                painting: {
                    views: []
                },
                screenWidth: '',
                innerHeight: '',

                mbType: '',
                mrrs: [],
            };
        },
        async created() {
            document.title = getDeptName()
            this.screenWidth = parseInt(window.innerWidth * 2);
            this.innerHeight = parseInt(window.innerHeight * 2);
            this.deptId = getDeptId()
            this.token = getCookie("spmToken")
            this.getMemberRewards()
            this.getMemberDeliveryItem()
        },
        methods: {
            onClick(index) {
                if (index == 1) {
                    this.mbType = 'TA'
                }
                if (index == 2) {
                    this.mbType = 'WO'
                }
                this.getSpmRewardRecords()
            },
            async getSpmRewardRecords() {
                let data = {
                    token: this.token,
                    mbType: this.mbType
                }
                let res = await this.$get("/spm/getSpmRewardRecords", data)
                this.mrrs = res.mrrs
            },

            async getMemberRewards() {
                let data = {
                    token: this.token,
                    deptId: this.deptId
                }
                let res = await this.$get("/spm/getSpmMemberRewards", data)
                this.mmrs = res.mmrs
            },

            async getMemberDeliveryItem() {
                let data = {
                    token: this.token,
                    deptId: this.deptId
                }
                let res = await this.$get("/spm/getSpmMbDeliveryItems", data)
                this.mdis = res.mdis
            },

            async toPoster(item) {
                this.showPoster = true
                let data = {
                    token: this.token,
                    imgUrl: item.imgUrl,
                    route: 'qkk',
                    id: item.id,
                }
                let res = await this.$post("/spm/getSpmGoodsPoster", data)
                let imgUrl = res.imgUrl
                let touxiang = res.headPortrait
                if (!touxiang) {
                    if (res.member.sex == 2) {
                        touxiang = require('./../../assets/nv.png')
                    } else {
                        touxiang = require('./../../assets/nan.png')
                    }
                }
                this.painting = {
                    position: 'relative',
                    width: '900px',
                    height: '1600px',
                    background: '#FFFFFF',
                    views: [
                        {
                            type: 'image',
                            url: imgUrl,
                            css: {
                                position: 'absolute',
                                top: '0%',
                                color: '#000',
                                background: '#fff',
                                width: '900px',
                                height: '900px',
                                borderWidth: '40px',
                                borderColor: '#fff',
                            },
                        },
                        {
                            type: 'image',
                            url: res.qrCode,
                            css: {
                                position: 'absolute',
                                right: '10%',
                                top: '63.7%',
                                color: '#000',
                                background: '#fff',
                                width: '210px',
                                height: '210px',
                                borderWidth: '20px',
                                borderColor: '#fff',
                            },
                        },
                        {
                            type: "text",
                            text: "- 长按识别查看 -",
                            css: {
                                top: "77%",
                                right: '5%',
                                width: "300px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "25px",
                                color: "#D3D3D3",
                            },
                        },
                        {
                            type: 'image',
                            url: touxiang,
                            css: {
                                position: 'absolute',
                                top: '64%',
                                left: '10%',
                                color: '#000',
                                background: '#fff',
                                width: '98px',
                                height: '98px',
                                borderRadius: '60px',
                            },
                        },
                        {
                            type: "text",
                            text: res.member.memberName,
                            css: {
                                top: "64%",
                                left: "23%",
                                width: "250px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "36px",
                                color: "#555555",
                            },
                        },
                        {
                            type: "text",
                            text: "推荐一个好物给你",
                            css: {
                                top: "67.5%",
                                left: "23%",
                                height: "30px",
                                padding: "5px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "28px",
                                color: "#8B8A8A",
                            },
                        },
                        {
                            type: "text",
                            text: item.icName,
                            css: {
                                top: "73%",
                                left: "23%",
                                width: "300px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "41px",
                                color: "#555555",
                            },
                        },
                        {
                            type: 'image',
                            url: require('./../../assets/md.png'),
                            css: {
                                position: 'absolute',
                                top: '89%',
                                left: '33%',
                                color: '#000',
                                background: '#fff',
                                width: '58px',
                                height: '58px',
                            },
                        },
                        {
                            type: "text",
                            text: res.deptName,
                            css: {
                                top: "89%",
                                left: "38%",
                                width: "300px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "45px",
                                color: "#8B8A8A",
                            },
                        },

                    ],
                }
            },


            // 保存图片到本地
            toSaveImage(img) {
            },

            // 海报生成
            success(src) {
                this.posterImg = src
            },
            fail() {

            },

            //赋值
            handleUpdateBg(row) {
                this.posterImg = ''
                this.painting.views[0].url = row.qrUrl
            },
            onClickLeft: function () {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-mmrs {
        margin: 0 auto;
        height: 100%;
        position: relative;
        background-color: #EEEEEE;
        padding-top: 53px;
    }

    .mmr-items {
        background-color: #ffffff;
        display: flex;
        flex-direction: row;
        margin: 5px 5px 0px 5px;
        padding: 10px;
        align-items: center;
    }

    .mmr-item {
        display: flex;
        flex-direction: column;
        width: 45%;
        margin-left: 16px;
    }

    .mmr-btn {
        height: 20px;
        width: 80px;
        background-color: #1256FA;
        font-size: 13px;
        line-height: 20px;
        text-align: center;
        color: #ffffff;
    }

    .qk-tou {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 15px;
        padding: 12px;
        background-color: #ffffff;
    }

    .content_container {
        width: 278px;
        height: 500px;
        overflow: hidden;
        margin: auto;
        background-size: 100% 100%;
    }

    .hb-img {
        width: 278px;
        height: 500px;
        background-size: 100% 100%;
    }

    .mrr-items {
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        margin: 5px 5px 0px 5px;
        padding: 10px;
    }

    .mrr-qkk {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 18px;
    }

    .mrr-sp {
        font-size: 11px;
        height: 25px;
    }
</style>
